module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-mpoker.e0504298.png";